import 'jquery';
import '../utils/slick.js';

if (jQuery('*').hasClass('list-box-slider-bk')) {
  var slider_item = jQuery('.list-box-slider-bk');

  var settings = {
    autoplaySpeed: 2000,
    prevArrow: "<div class='arrow_data arrow-left'> </div>",
    nextArrow: "<div class='arrow_data arrow-right'> </div>",
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    infinite: true,
    autoplay: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  slider_item.slick(settings);
  jQuery(window).on('resize load', function () {
    jQuery('.list-box-slider-bk').slick('refresh');
    resizeSlider();
    if (jQuery(window).width() < 992) {
      var innerBoxItem = jQuery('.list-box-slider-bk .inner-box-item');
      innerBoxItem.removeAttr('data-sal data-sal-duration data-sal-delay');
    }
  });

  var slickHeight = jQuery('.list-box-slider-bk .slick-track').outerHeight();

  jQuery('.list-box-slider-bk .slick-track')
    .find('.slick-slide .inner-box-item')
    .css('height', slickHeight + 'px');

  function resizeSlider() {
    jQuery('.list-box-slider-bk .slick-track')
      .find('.slick-slide .inner-box-item')
      .css('height', slickHeight + 'px');
  }
}
